import { RefreshCcw } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Dispatch, FC, SetStateAction } from "react";
import { cn, getLabel } from "@/utils/utils";
import TrackDifficultyFilter from "./TrackDifficultyFilter";

interface Props {
  filters: string[];
  setSelectedFilters: Dispatch<SetStateAction<string[]>>;
  selectedFilters: string[];
  query: string;
  setQuery: Dispatch<SetStateAction<string>>;
  setDifficulty: Dispatch<SetStateAction<string | null>>;
}

const TrackFilters: FC<Props> = ({
  filters,
  setSelectedFilters,
  selectedFilters,
  query,
  setQuery,
  setDifficulty,
}) => {
  const handleReset = () => {
    setSelectedFilters([]);
    setQuery("");
    setDifficulty("all");
  };

  return (
    <div className="flex w-full gap-2 flex-col">
      <div className="flex gap-2">
        <Button
          variant={"outline"}
          title="reset filters"
          className="text-black shadow-none size-[40px]"
          onClick={handleReset}
        >
          <RefreshCcw />
        </Button>
        <TrackDifficultyFilter setDifficulty={setDifficulty} />
        <Input
          placeholder="Search"
          className="h-[40px] shadow-none"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>
      <div className="flex gap-2 flex-wrap">
        {filters.map((filter, index) => (
          <div
            key={index}
            className={cn(
              "rounded-full border px-2 py-1 text-[14px] text-[#6941C6] border-[#D9D6FE]",
              selectedFilters.includes(filter) ? "bg-[#edecff97]" : "bg-[#fff]"
            )}
            role="button"
            onClick={() =>
              setSelectedFilters((f) =>
                f.includes(filter)
                  ? f.filter((f) => f !== filter)
                  : [...f, filter]
              )
            }
          >
            {getLabel(filter)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrackFilters;
